import { IconType, SvgIcon } from './SvgIcon';

export const MinimizeIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <rect width="26" height="26" rx="13" fill="#2540F5" />
    <path
      d="M11.8333 11.834L7.75 7.75065"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.833 8.33398V11.834L8.33301 11.834"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2503 18.25L14.167 14.1667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.167 17.666L14.167 14.166H17.667"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

MinimizeIcon.displayName = 'MinimizeIcon';
